const normalize = (num: number, scale: number = 1000) => Math.round(num * scale);

/** Tries to handle floating point errors. */
export const safeRemainder = (a: number, b: number, scale: number = 1000): number => {
    return normalize(a, scale) % normalize(b, scale) / scale;
};
